var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStep3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 61.84,
    height: 65.904,
    viewBox: "0 0 61.84 65.904",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Clip_2",
    "data-name": "Clip 2",
    d: "M0,0H61.84V20.9H0Z",
    transform: "translate(0 0.104)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Clip_5",
    "data-name": "Clip 5",
    d: "M0,0H42.831V55.78H0Z",
    transform: "translate(0.128 0.096)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7",
    "data-name": "Group 7",
    transform: "translate(0 -0.096)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(0 45)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Clip_2-2",
    "data-name": "Clip 2",
    d: "M0,0H61.84V20.9H0Z",
    transform: "translate(0 0.104)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3-2",
    "data-name": "Group 3",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill_1",
    "data-name": "Fill 1",
    d: "M13.48,0Q14.966,2.045,16.6,3.99c-1.406.27-2.8.6-4.177,1q-.91.26-1.808.574A22.616,22.616,0,0,0,7.656,6.816,10.34,10.34,0,0,0,5.8,8.02c-.086.068-.169.145-.253.222l-.214.213c-.06.065-.119.133-.172.2A1.32,1.32,0,0,0,4.776,9.7a1.632,1.632,0,0,0,.336.659,5.008,5.008,0,0,0,.984.934,11.551,11.551,0,0,0,1.561.968A22.22,22.22,0,0,0,10.4,13.439a38.687,38.687,0,0,0,4.019,1.176c1.487.352,2.994.639,4.5.869a78.8,78.8,0,0,0,11.993.869,78.8,78.8,0,0,0,11.993-.869c1.51-.23,3.017-.517,4.5-.869a38.687,38.687,0,0,0,4.019-1.176,22.22,22.22,0,0,0,2.747-1.181,11.551,11.551,0,0,0,1.561-.968,5.014,5.014,0,0,0,.984-.934,1.629,1.629,0,0,0,.336-.659,1.328,1.328,0,0,0-.384-1.039c-.056-.068-.116-.137-.175-.2l-.214-.213c-.083-.077-.166-.151-.253-.222a10.329,10.329,0,0,0-1.855-1.2,22.588,22.588,0,0,0-2.958-1.255q-.9-.315-1.808-.574c-1.373-.4-2.771-.724-4.174-1Q46.868,2.044,48.363,0c.449.108.895.216,1.341.335q1.467.383,2.911.872c.645.224,1.287.463,1.915.724.517.216,1.029.443,1.531.693.339.17.675.346,1,.534.256.145.505.3.752.454A8.587,8.587,0,0,1,61.59,7.946a5.412,5.412,0,0,1,.184.781,4.908,4.908,0,0,1,.047,1.216,5.173,5.173,0,0,1-.369,1.562A6.789,6.789,0,0,1,60.187,13.5a11.715,11.715,0,0,1-2.741,2.2,23.9,23.9,0,0,1-4.338,2,44.859,44.859,0,0,1-5.711,1.6,69.808,69.808,0,0,1-7.748,1.187c-2.9.287-5.815.42-8.729.42s-5.83-.134-8.729-.42a69.808,69.808,0,0,1-7.748-1.187,44.848,44.848,0,0,1-5.711-1.6A24.312,24.312,0,0,1,4.582,15.8a12.175,12.175,0,0,1-2.795-2.159A7.057,7.057,0,0,1,.461,11.689,5.5,5.5,0,0,1,.018,9.943,4.906,4.906,0,0,1,.066,8.727,5.539,5.539,0,0,1,.25,7.943,8.425,8.425,0,0,1,3.841,3.729q.366-.239.74-.458c.324-.193.657-.372.99-.545q.745-.375,1.51-.7c.624-.264,1.257-.506,1.9-.73.859-.3,1.73-.568,2.607-.812C12.213.31,12.844.151,13.48,0Z",
    transform: "translate(0 0.104)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6",
    transform: "translate(9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Clip_5-2",
    "data-name": "Clip 5",
    d: "M0,0H42.831V55.78H0Z",
    transform: "translate(0.128 0.096)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6-2",
    "data-name": "Group 6",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill_4",
    "data-name": "Fill 4",
    d: "M21.416,55.78h0A89.352,89.352,0,0,1,10.708,44.76,60.236,60.236,0,0,1,3.346,33.578,28.931,28.931,0,0,1,0,20.918,20.538,20.538,0,0,1,6.275,6.129a21.763,21.763,0,0,1,30.28,0,20.538,20.538,0,0,1,6.275,14.788,28.931,28.931,0,0,1-3.346,12.66A60.235,60.235,0,0,1,32.123,44.76,89.351,89.351,0,0,1,21.416,55.78Zm-11.3-37.506V23.1h8.825v8.62h4.943V23.1h8.825V18.274H23.887V9.653H18.944v8.621Z",
    transform: "translate(0.128 0.095)",
    fill: "#444"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep3);
export default __webpack_public_path__ + "static/media/step-3.1392b18a66f9c7bcaeefad6370fc56ff.svg";
export { ForwardRef as ReactComponent };